<template>
  <div class="w-100">
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('statistics.filter.country')"
            label-for="country"
        >
          <multiselect
              id="country"
              :options="countries"
              :multiple="false"
              v-model="country"
              label="label"
              track-by="key"
              :placeholder="$t('form.statistics.placeholder.country')"
          >
          </multiselect>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('statistics.filter.gender')"
            label-for="dateFrom"
        >
          <multiselect
              :options="sex"
              :multiple="false"
              v-model="gender"
              label="label"
              track-by="key"
              :placeholder="$t('form.statistics.placeholder.gender')"
          >
          </multiselect>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('statistics.filter.age')"
            label-for="age"
        >
          <multiselect
              :options="options.age"
              :multiple="false"
              v-model="ageRange"
              label="text"
              track-by="value"
              :placeholder="$t('form.statistics.placeholder.age')"
          >
          </multiselect>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('statistics.filter.date')"
            label-for="date"
        >
          <date-range-picker
                             id="date"
                             v-model="date"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="false"
                             :time-picker="false"
                             :ranges="false"
                             :opens="'left'">
          </date-range-picker>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('statistics.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('statistics.btn.apply') }}</b-button>
      </div>
    </div>
    <div class="table-responsive">
      <table v-if="player && !isBusy" class="table table-striped mt-4">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">{{ $t('table.header.statistics.player.custom_date') }}</th>
            <th scope="col">{{ $t('table.header.statistics.player.last_year') }}</th>
            <th scope="col">{{ $t('table.header.statistics.player.last_month') }}</th>
            <th scope="col">{{ $t('table.header.statistics.player.last_week') }}</th>
            <th scope="col">{{ $t('table.header.statistics.player.yesterday') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{{ $t('table.row.statistics.player.registered_players') }}</th>
            <td class="text-center">{{  player['registered_players']['custom_date'] }}</td>
            <td class="text-center">{{  player['registered_players']['last_year'] }}</td>
            <td class="text-center">{{  player['registered_players']['last_month'] }}</td>
            <td class="text-center">{{  player['registered_players']['last_week'] }}</td>
            <td class="text-center">{{  player['registered_players']['yesterday'] }}</td>
          </tr>

          <tr>
            <th scope="row">{{ $t('table.row.statistics.player.active_players') }}</th>
            <td class="text-center">{{  player['active_players']['custom_date'] }}</td>
            <td class="text-center">{{  player['active_players']['last_year'] }}</td>
            <td class="text-center">{{  player['active_players']['last_month'] }}</td>
            <td class="text-center">{{  player['active_players']['last_week'] }}</td>
            <td class="text-center">{{  player['active_players']['yesterday'] }}</td>
          </tr>

          <tr>
            <th scope="row">{{ $t('table.row.statistics.player.deposit_players') }}</th>
            <td class="text-center">{{  player['deposit_players']['custom_date'] }}</td>
            <td class="text-center">{{  player['deposit_players']['last_year'] }}</td>
            <td class="text-center">{{  player['deposit_players']['last_month'] }}</td>
            <td class="text-center">{{  player['deposit_players']['last_week'] }}</td>
            <td class="text-center">{{  player['deposit_players']['yesterday'] }}</td>
          </tr>

          <tr>
            <th scope="row">{{ $t('table.row.statistics.player.first_time_deposit_players') }}</th>
            <td class="text-center">{{  player['first_time_deposit_players']['custom_date'] }}</td>
            <td class="text-center">{{  player['first_time_deposit_players']['last_year'] }}</td>
            <td class="text-center">{{  player['first_time_deposit_players']['last_month'] }}</td>
            <td class="text-center">{{  player['first_time_deposit_players']['last_week'] }}</td>
            <td class="text-center">{{  player['first_time_deposit_players']['yesterday'] }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="col-12">
        <div class="spinner-wrapper" >
          <b-spinner></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  components: {
    DateRangePicker,
    Multiselect
  },
  data() {
    return {
      country: null,
      gender: null,
      ageRange: null,
      date: {
        startDate: null,
        endDate: null
      },
      options: {
        age: [
          {value: '18/26', text: this.$t('statistics.options.age_18-26')},
          {value: '27/36', text: this.$t('statistics.options.age_27-36')},
          {value: '37/46', text: this.$t('statistics.options.age_37-46')},
          {value: '47/56', text: this.$t('statistics.options.age_47-56')},
          {value: '57+', text: this.$t('statistics.options.over_57_age')}
        ]
      }
    }
  },
  computed: {
    ...mapState({
      player: (state) => state.statistics.player,
      countries: (state) => state.root.dictionaries.country,
      sex: (state) => state.root.dictionaries.sex,
      isBusy: (state) => state.statistics.isBusy
    }),
  },
  mounted() {
    this.date.startDate = moment();
    this.date.endDate = moment();

    this.getReport();
  },
  beforeDestroy() {
    this.$store.commit('statistics/setPlayer', null);
  },
  methods: {
    clearFilters() {
      this.dateFrom = { startDate: moment() };
      this.dateTo = { startDate: moment() };
      this.ageRange = null;
      this.country = null;
      this.gender = null;

      this.getReport();
    },
    getReport() {
      const payload = {
        ageRange: this.ageRange ? this.ageRange.value : null,
        gender: this.gender ? this.gender.key : null,
        country: this.country ? this.country.key : null,
        dateFrom: this.date.startDate ? moment(this.date.startDate).format('YYYY-MM-DD') : null,
        dateTo: this.date.endDate ? moment(this.date.endDate).format('YYYY-MM-DD') : null
      }

      this.$store.dispatch('statistics/getPlayer', payload);
    }
  }
}
</script>
